import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import CreateJobStepper from "../../../../../components/CreateJobStepper";

import BasicDetails from "./BasicDetails";
import AdvancedTargeting from "./AdvancedTargeting";
import RequiredSubmissionInfo from "./RequiredSubmissionInfo";
import CompensationAndBenefits from "./CompensationAndBenefits";

const JobDetailsStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.jobDetails" });

  return (
    <Box sx={styles.container}>
      <Box sx={styles.stepContainer}>
        <CreateJobStepper />
        <Box sx={styles.content} component="main">
          <Typography sx={styles.title}>{t("jobDetails")}</Typography>
          <BasicDetails />
          <CompensationAndBenefits />
          <AdvancedTargeting />
          <RequiredSubmissionInfo />
        </Box>
      </Box>
    </Box>
  );
};

export default JobDetailsStep;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  stepContainer: {
    display: "flex",
    gap: "24px",
    width: "max(1140px, 80%)",
    margin: "0 auto",
    flex: 1,
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "20px 24px",
    minWidth: 0,
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
};
